import { render, staticRenderFns } from "./SideMenu-inner.vue?vue&type=template&id=d3c67990"
import script from "./SideMenu-inner.vue?vue&type=script&lang=js"
export * from "./SideMenu-inner.vue?vue&type=script&lang=js"
import style0 from "./SideMenu-inner.vue?vue&type=style&index=0&id=d3c67990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports